import { timeConvert } from '@/helpers/timeHelper';
import { Image, Spin } from 'antd';
import axios from 'axios';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export type MockTestDataType = {
  title: string;
  price: number;
  discount_percentage: number;
  discount_price: number;
  image: string;
  currency: string;
  duration: string;
  subject: string;
  slug: string;
  test_type: string;
  id: number;
  has_completed_test: boolean;
};

type DataProps = {
  modalData: MockTestDataType;
};

const PaidCourseModal: FC<DataProps> = ({ modalData }) => {
  const dispatch = useDispatch();

  //lodaing state
  const [loading, setLoading] = useState(false);

  //enroll state
  const [isEnroll, setIsEnroll] = useState();

  const discountedPrice = modalData?.discount_percentage
    ? modalData?.price - modalData?.price * (modalData?.discount_percentage / 100) ||
      modalData?.price - modalData?.discount_price
    : modalData?.price;

  const router = useRouter();

  useEffect(() => {
    if (modalData) {
      setLoading(true);
      axios({
        method: 'GET',
        headers: {
          Authorization: `${localStorage.getItem('token')}`,
        },
        url: `${process.env.NEXT_PUBLIC_BASE_URL}mocktest-check-enroll/${modalData?.slug}/`,
      })
        .then((res) => {
          setIsEnroll(res?.data?.is_enroll);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  }, [modalData]);

  //For displaying mock test price
  const FirstStep = () =>
    loading ? (
      <Spin />
    ) : (
      <div className="card-body p-0 m-0">
        <div>
          <Image
            width={200}
            src={
              modalData?.image
                ? modalData?.image
                : 'https://learnsic.com/images/course.jpg'
            }
            alt="mock-test"
          />
        </div>
        <h5 className="mb-2 d-flex align-items-center justify-content-center my-3">
          {modalData?.title}
        </h5>
        <h4 style={{ fontWeight: '600' }}>
          {modalData?.price && (
            <>
              <small className="text-muted">
                {modalData?.discount_percentage || modalData?.discount_price ? (
                  <del>
                    {modalData?.currency || 'Rs.'} {modalData.price || ''}
                  </del>
                ) : (
                  <small className="text-muted">
                    {modalData?.currency || 'Rs.'} {modalData.price || ''}
                  </small>
                )}
              </small>
              <br></br>
            </>
          )}
          {discountedPrice &&
            (modalData?.discount_percentage || modalData?.discount_price) && (
              <small className="text-muted">
                {modalData?.currency || 'Rs.'} {discountedPrice}
              </small>
            )}
        </h4>
        <ul className="list-unstyled mt-2 mb-3">
          <li>
            {modalData?.duration && (
              <div className="mock-duration mt-2">
                <span className="text-dark font-weight-bold ">Duration:</span>
                <span className="dur ml-2" style={{ fontWeight: '600' }}>
                  {parseFloat(modalData?.duration) > 60
                    ? timeConvert(modalData?.duration)
                    : modalData?.duration}
                </span>
              </div>
            )}
          </li>
          <li>
            {modalData?.subject && (
              <div className="mock-subject mt-2">
                <span className="text-dark font-weight-bold">Subject:</span>{' '}
                <span className="sub ml-2" style={{ fontWeight: '600' }}>
                  {modalData?.subject}
                </span>
              </div>
            )}
          </li>
        </ul>
        <div className="d-flex justify-content-center align-items-center gap-3">
          <button
            type="button"
            className="btn btn-sm btn-block btn-primary border-primary m-0"
            onClick={() => {
              // setStep(2)
              // isEnroll
              //   ? router.push(`/mock-test/normal/${modalData?.slug}`)
              //   : router.push(`payment/${modalData?.slug}`);
              if (isEnroll == true) {
                const href = `/mock-test/${
                  modalData?.has_completed_test
                    ? 'reports'
                    : modalData.test_type == 'LISTENING'
                    ? 'listening'
                    : modalData.test_type == 'WRITING'
                    ? 'writing'
                    : modalData.test_type == 'READING'
                    ? 'reading'
                    : modalData.test_type == 'SPEAKING'
                    ? 'speaking'
                    : 'normal'
                }/${modalData.slug}`;
                router.push(`${href}`);
              } else {
                router.push(`payment/${modalData?.slug}`);
              }
            }}
          >
            {modalData?.has_completed_test
              ? 'View Report'
              : isEnroll
              ? 'Continue Learning'
              : 'Buy'}
          </button>
        </div>
      </div>
    );
  return (
    <div className="card-deck mb-2 p-2 text-center">
      <div className="card p-3 shadow-none ">
        <FirstStep />
      </div>
    </div>
  );
};

export default PaidCourseModal;
